<template>
    <div class="boleto-message">
        <p class="boleto-success-title text-center my-4" v-text="$ml.get('thanks')" />
        <p v-text="$ml.get('boletoSuccessBody')" />

        <p v-text="$ml.get('barcode')" />
        <strong
            class="d-block text-center mt-4 mb-2 text-break" 
            style="color: #5A646E"
        >{{ boletoNumber || $ml.get('notAvailable') }}</strong>

        <CopyButton
            @click-copy="copyBarcodeNumber"
        />

        <a target="_blank" :href="boletoUrl" class="btn btn-light mt-2" v-text="$ml.get('openBoleto')" />
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { CopyToClipboard } from '@/helpers/clipboardHelper';
import CopyButton from '@/components/CopyButton.vue';

export default {
    components: {
        CopyButton
    },
    computed: {
        ...mapState({
            boletoNumber: state => state.boletoPayment.Response.BoletoNumber,
            boletoUrl: state => state.boletoPayment.Response.BoletoViewUrl
        }),
    },
    methods: {
        copyBarcodeNumber() {
            CopyToClipboard(this.boletoNumber);
        }
    }
};
</script>

<style lang="scss" scoped>
    .boleto-message {
        text-align: center;

        .boleto-success-title {
            color: #43B977;
            font-weight: bold;
        }
    }

    .copy-btn {
        display: block;
        margin: 0 auto;
    }
</style>